import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SEMINAR_INFORMATION_STATUS_PUBLIC } from '../../../../../define/consts/seminar/seminar_information';
import { propId, propShape } from '../../../../../helpers/custom-prop-types';
const SeminarOneTitle = (props) => {
    const { id, seminar } = props;
    const { originalStatus } = seminar;
    const isPublic = originalStatus === SEMINAR_INFORMATION_STATUS_PUBLIC.value;
    if (!id) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: clsx('professional_seminar_one_title', isPublic && 'public') }, { children: _jsx("div", Object.assign({ className: 'title_text' }, { children: `このセミナーは【${isPublic ? '公開状態' : '下書き（非公開）'}】です` })) })));
};
SeminarOneTitle.propTypes = {
    id: propId(),
    seminar: propShape().isRequired,
};
SeminarOneTitle.defaultProps = {
    id: null,
};
export default SeminarOneTitle;
